import useBaskets from "../../data/useBaskets";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IBasketItem } from "../../models/Basket";


export default function UpdateTaxRate({ basketItem }: { basketItem: IBasketItem }) {
  const { updateItem } = useBaskets("UpdateTaxRate");
  const { saveHandlers } = useDefaultCRUDHandlers("Basket Item");


  const handlePriceUpdate = (value: string) => {
    const updatedBasketItem: IBasketItem = {
      ...basketItem,
      taxRate: parseFloat(value),
    };

    updateItem.mutate(updatedBasketItem, saveHandlers);
  };

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>
      % <input
        key={basketItem.id}
        defaultValue={basketItem.taxRate}
        className="h-8 border p-1 ml-2 text-sm w-full"
        type="number" step={0.01} min={0}
        onBlur={(e) => handlePriceUpdate(e.target.value)}
      />
    </div>
  )
}